// extracted by mini-css-extract-plugin
module.exports = {"deletePolicyButton":"src-hellosign-components-my-settings-purge-document-settings__deletePolicyButton--2UD5X"};